import { type AxiosPromise } from "axios"
import httpModule from "../../../../utils/http"

export const getPreference = async (): Promise<AxiosPromise<any>> =>
  await httpModule.get(`/api/backoffice/v1/configuracion`)

export const putPreference = async (request): Promise<AxiosPromise<any>> =>
  await httpModule.put(`/api/backoffice/v1/configuracion`, request)
